import React, { useEffect, useMemo, useState } from 'react';
import { Button, Grid, Typography } from '@mui/material';
import MarketDataGrid from 'src/App/Pages/MarketExplorer/MarketDataGrid';
import { ALL_COUNTRY, COLOR_PRIMARY, MARKET_FINDER_COLUMN_METADATA } from 'src/const';
import { callApi } from 'src/core/callApi';
import OpenInNew from '@mui/icons-material/OpenInNew';
import { LoadingCard } from 'src/App/HOC';

interface Top10MarketsProps {
  currency: string;
  isLoggedIn: boolean;
  countryCode: string;
  hideBluredRows?: boolean;
}

const Top10Markets: React.FC<Top10MarketsProps> = ({ currency, isLoggedIn, countryCode, hideBluredRows }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [markets, setMarkets] = useState<any[]>([]);

  const reDirectURL = `/markets/compare?countryCode=${countryCode}`;

  const fetchData = async () => {
    setIsLoading(true);
    const requestBody: any = {
      lock_type: 'v2',
      country_codes: [countryCode],
      // regulations: ['lenient'],
      sort_by: 'supply',
      is_premium_request: false,
    };

    const URL = 'https://niyu2lp99j.execute-api.us-east-2.amazonaws.com/default/getBestMarkets';
    const response = await callApi(URL, { body: requestBody }, true, false, '', 'POST', true);

    if (response && response.message && response.message.markets) {
      setMarkets(response.message.markets.slice(0, 10));
    }
    setIsLoading(false);
  };

  useEffect(() => {
    countryCode && fetchData();
  }, [countryCode]);

  const processedMarkets = useMemo(() => {
    let effectiveMarkets = [...markets];
    return effectiveMarkets.map(market => {
      const hasLockedValues = Object.values(market).some(value => value === 'locked');
      return {
        ...market,
        _blurState: hasLockedValues ? 'blurAll' : 'none',
      };
    });
  }, [markets]);

  return (
    <Grid container item xs={12} justifyContent={'center'}>
      <Grid item xs={12}>
        {isLoading && <LoadingCard type="bars" height={140} />}
        {!isLoading && processedMarkets && processedMarkets.length > 0 && (
          <>
            <Typography variant="h6">
            Explore Short Term Rental Markets in{' '}
              <span style={{ color: COLOR_PRIMARY }}>{ALL_COUNTRY[countryCode]}</span>
            </Typography>
            <MarketDataGrid
              data={processedMarkets}
              metadata={MARKET_FINDER_COLUMN_METADATA}
              isFreeUser={true}
              isLoggedIn={isLoggedIn}
              handleOnSampleClick={() => {}}
              currency={currency}
              selectedBudget={{
                type: 'buy',
                range: { min: 0, max: 0 },
              }}
              currentRequestType={'free'}
              openCreditDeductModal={() => {}}
              selectedList={'loading'}
              selectedListError={false}
              showSavedMarketLoadingError={false}
              setShowSavedMarketLoadingError={() => {}}
              handleSidebarClick={() => {}}
              handleSidebarListItemClick={() => {}}
              selectedSortBy={'supply'}
              hidePagination={true}
              hideSaveColumn={true}
              hideUnlockButton={true}
              hideBluredRows={hideBluredRows}
            />
            <Grid container justifyContent={'center'}>
              <Button
                variant="contained"
                color="primary"
                endIcon={<OpenInNew />}
                onClick={() => {
                  window.open(reDirectURL, '_self');
                }}
                sx={{ mt: 2, color: '#fff', fontSize: '20px' }}
              >
                Explore most profitable markets
              </Button>
            </Grid>
          </>
        )}
      </Grid>
    </Grid>
  );
};

export default Top10Markets;
